// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaintVincentGrenadines from '../_raw/flag/icon_flag_saint_vincent_grenadines.png';

export default () => <img src={SaintVincentGrenadines} alt="SaintVincentGrenadines" />;
